import { render, staticRenderFns } from "./PrivacyOffice.vue?vue&type=template&id=18dc913e&scoped=true"
import script from "./PrivacyOffice.vue?vue&type=script&lang=js"
export * from "./PrivacyOffice.vue?vue&type=script&lang=js"
import style0 from "./PrivacyOffice.vue?vue&type=style&index=0&id=18dc913e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc913e",
  null
  
)

export default component.exports